/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import clsx from 'clsx';

import styles from './CollapseToggleButton.module.scss';

type CollapseToggleButtonProps = {
  collapsed: boolean;
  collapsedLabel: string;
  collapseTitle: string;
  expandTitle: string;
  onClick: () => void;
  className?: string;
};

export function CollapseToggleButton({
  collapsed,
  collapsedLabel,
  collapseTitle,
  expandTitle,
  onClick,
  className,
}: CollapseToggleButtonProps) {
  const title = collapsed ? expandTitle : collapseTitle;

  return (
    <Tooltip title={title}>
      <IconButton
        className={clsx(styles.button, collapsed && styles.collapsed, className)}
        onClick={onClick}
        aria-label={title}
        size="small"
      >
        {collapsed ? <ExpandCircleDownIcon /> : <RemoveCircleIcon />}
        {collapsed && <span className={styles.collapsedLabel}>{collapsedLabel}</span>}
      </IconButton>
    </Tooltip>
  );
}
